import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import img1 from './images/kits/k1.jpeg';
import img2 from './images/kits/k2.jpeg';
import img3 from './images/kits/k3.jpeg';
import kit2 from './images/kits/kit2.jpg';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
function Order()
{
    let [formData,setFormData]=useState({orderdate:"",email:"",name:"",mobile:"",address:"",city:"",state:"",pincode:"",details:"",amount:0,kit:0});
    let param=useParams();
    let nav=useNavigate();
    function dataChange(event)
    {
        if(event.target.id=="email") setFormData({...formData,email:event.target.value});
        if(event.target.id=="name") setFormData({...formData,name:event.target.value});
        if(event.target.id=="mobile") setFormData({...formData,mobile:event.target.value});
        if(event.target.id=="address") setFormData({...formData,address:event.target.value});
        if(event.target.id=="city") setFormData({...formData,city:event.target.value});
        if(event.target.id=="state") setFormData({...formData,state:event.target.value});
        if(event.target.id=="pincode") setFormData({...formData,pincode:event.target.value});
        if(event.target.id=="details") setFormData({...formData,details:event.target.value});
    }
    function orderSave(event)
    {
        event.preventDefault();
        if(formData.name.trim().length<4)
        {
            alert("Invalid Name....");
            document.getElementById("name").focus();
            return;
        }
        if(formData.mobile.trim().length!=10)
        {
            alert("Invalid Mobile....");
            document.getElementById("mobile").focus();
            return;
        }
        if(formData.address.trim().length<10)
        {
            alert("Invalid Address....");
            document.getElementById("address").focus();
            return;
        }
        if(formData.state.trim().length<2)
        {
            alert("Invalid State....");
            document.getElementById("state").focus();
            return;
        }
        if(formData.city.trim().length<3)
        {
            alert("Invalid City....");
            document.getElementById("city").focus();
            return;
        }
        if(formData.pincode.trim().length!=6)
        {
            alert("Invalid Pin Code...");
            document.getElementById("pincode").focus();
            return;
        }
        const apiClient = axios.create({
                    baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                    headers: {
                        'Content-Type': 'application/json',                        
                    }
                });  
        let d=new Date(); 
        let data={...formData,orderdate:d.toISOString().split("T")[0]};   
        apiClient.post("orders",data).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setFormData({orderdate:"",email:"",name:"",mobile:"",address:"",city:"",state:"",pincode:"",details:"",amount:0,kit:0});
                alert("Thanks for your Order.\nWe will contact you as soon as possible")
                nav("/");
            }
        });         
    }
    useEffect(()=>{
        if(param.id==1)
        {
            setFormData({...formData,amount:15500,kit:1});
        }
        else
        {
            setFormData({...formData,amount:10500,kit:2});
        }
    },[]);
    return (    
    <div className="min-h-screen">
      <Header />      
      <main>        
        {/* Intro Section */}
        <section className="py-24 bg-black">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
                

                <form onSubmit={orderSave} className="max-w-md mx-auto mt-5">
                    <div className="relative z-0 w-full mb-5 group">
                        <input type="email" onChange={dataChange} value={formData.email} name="email" id="email" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " />
                        <label for="email" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Email address</label>
                    </div>
                    <div className="relative z-0 w-full mb-5 group">
                        <input type="text" onChange={dataChange} value={formData.name}  name="name" id="name" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required />
                        <label for="name" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Full Name*</label>
                    </div>
                    <div className="relative z-0 w-full mb-5 group">
                        <input type="tel" onChange={dataChange} value={formData.mobile}  pattern="[0-9]{10}" name="mobile" id="mobile" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required />
                        <label for="mobile" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Mobile No*</label>
                    </div>
                    <div className="relative z-0 w-full mb-5 group">
                        <textarea pattern="[0-9]{10}" onChange={dataChange} value={formData.address}  name="address" id="address" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required ></textarea>
                        <label for="address" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Complete Address*</label>
                    </div>
                    <div className="grid md:grid-cols-2 md:gap-6">
                        <div className="relative z-0 w-full mb-5 group">
                            <input type="text"  onChange={dataChange} value={formData.city}  name="city" id="city" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required />
                            <label for="city" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">City*</label>
                        </div>
                        <div className="relative z-0 w-full mb-5 group">
                            <input type="text" onChange={dataChange} value={formData.state}  name="state" id="state" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required />
                            <label for="state" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">State*</label>
                        </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:gap-6">
                        <div className="relative z-0 w-full mb-5 group">
                            <input type="tel"  onChange={dataChange} value={formData.pincode}  pattern="[0-9]{6}" name="pincode" id="pincode" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required />
                            <label for="pincode" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Pin Code*</label>
                        </div>
                        <div className="relative z-0 w-full mb-5 group">
                            <input type="text"  onChange={dataChange} value={formData.details}  name="details" id="details" className="block py-2.5 px-0 w-full text-sm text-heading bg-transparent border-0 border-b-2 border-default-medium appearance-none focus:outline-none focus:ring-0 focus:border-brand peer" placeholder=" " required />
                            <label for="other" className="absolute text-sm text-body duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-fg-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Other Details (if any)</label>
                        </div>
                    </div>
                    <div className='mt-2'>
                        We have a Team of Specialist. One of our Team Member will call you to discuss the problems and to confirm your order before shipping.
                    </div>                    
                    <div  className='mt-2'>
                        हमारे पास विशेषज्ञों की एक टीम है। शिपिंग से पहले, हमारी टीम का एक सदस्य आपसे संपर्क करके आपकी समस्याओं पर चर्चा करेगा और आपके ऑर्डर की पुष्टि करेगा।
                    </div>
                    <div className='mt-2 mb-3'>
                        Order Summary / ऑर्डर का विवरण<br/>
                        {param.id==1 && (<div className='p-3 mt-2'>
                            <img src={img2} width="80%" /><br/>
                            Amount &#x20B9; 15,500/-
                        </div>)}
                        {param.id==2 && (<div className='p-3 mt-2'>
                            <img src={kit2} width="80%" style={{borderRadius:'20px'}} /><br/>
                            Amount &#x20B9; 10,500/-
                        </div>)}
                    </div>
                    <button type="submit" style={{backgroundColor:'#EEBA36'}} className="text-black box-border border border-transparent hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none">Place Order</button>
                </form>
       
            </div>
          </div>
        </section>        
      </main>
      <Footer />
    </div>
  );  
}

export default Order;
